import React from 'react'
import PropTypes from 'prop-types'
import { Filter } from '@ExcelFilterRules/components/Filters'
import { Table } from '@ExcelFilterRules/components/Table'
import { useExcelRules } from '@ExcelFilterRules/hooks/useFilter'

export function App({ excel_rules_data }) {
  const { filters, data, updateFilterState, applyFilterState, clearFilters } =
    useExcelRules(excel_rules_data)
  return (
    <div className="card-myed">
      <Filter
        filters={filters}
        updateFilterState={updateFilterState}
        applyFilterState={applyFilterState}
        clearFilters={clearFilters}
      />
      <Table data={data} />
    </div>
  )
}

App.propTypes = {
  excel_rules_data: PropTypes.any.isRequired,
}
